module.exports = __webpack_public_path__ + "img/dp158_04.e29222dc.jpg";